import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl1ValidationSchema = () => {
  const { t } = useTranslation();
  const minDate = new Date("1900-01-01");
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktDSDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900"))
      .max(new Date(), t("Μέχρι σήμερα")),
    fudocPraktDS: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coAddress: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coAddressNumber: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coZipCode: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .matches(/^\d{5}$/, t("Το πεδίο πρέπει να αποτελείται από 5 ψηφία")),
    coCity: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coRegion: yup.string().max(50),
  });
};
